module.exports = __webpack_public_path__ + "static/media/whiteLogo.e97c0314.png";